export default __webpack_public_path__ + "static/media/fummiNcake_w320.dd5ad484.jpeg";